__turbopack_context__.v({
  "ember": "Fire-module__RQjfla__ember",
  "root": "Fire-module__RQjfla__root",
});
